module.exports = __webpack_public_path__ + "img/easter_tour.1105d9ca.png";